import { OptionType } from 'components';

export enum HasSalaryContinuation {
    No = 'NON',
    Full = 'INT',
    Partial = 'PAR',
}

export const maintienInterruptionActivityS6202Options: OptionType[] = [
    { label: 'Non', value: HasSalaryContinuation.No },
    { label: 'Intégralement', value: HasSalaryContinuation.Full },
    { label: 'Partiellement', value: HasSalaryContinuation.Partial },
];
